
const EMPTY_STRING = '';
class ContentTV  {
    constructor(tv) {
        Object.assign(this, tv);
        this.mediaState = tv.mediaState?.mediaStateCode || tv.mediaState || EMPTY_STRING;
        this.id = tv.id || EMPTY_STRING;
        this.mediaFeedType = tv.homeAway?.toUpperCase() || tv.mediaFeedType || EMPTY_STRING;
        this.mediaFeedTypeKey = this.mediaFeedType.toLowerCase();
        this.language = tv.language && tv.language.toLowerCase() || EMPTY_STRING;
    }
}

export default ContentTV;
